import * as tslib_1 from "tslib";
import getSuggestionMenuItemsSelector from '../selectors/getSuggestionMenuItemsSelector';
import { getStore } from '../store/store';
import { observer } from 'mobx-react';
import { lazyLogResponseRendered } from 'owa-search-service';
import * as React from 'react';
import { ContextualMenu, } from 'office-ui-fabric-react/lib/components/ContextualMenu';
var SuggestionsContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionsContextMenu, _super);
    function SuggestionsContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suggestions = [];
        return _this;
    }
    SuggestionsContextMenu.prototype.render = function () {
        var _this = this;
        return (React.createElement(ContextualMenu, { calloutProps: {
                preventDismissOnScroll: true,
            }, directionalHint: 4 /* bottomLeftEdge */, directionalHintFixed: true, gapSpace: 2, items: this.getSuggestionMenuItems(), onDismiss: function (evt) {
                _this.props.onBlur(evt);
            }, shouldFocusOnMount: false, target: this.props.targetElement, useTargetWidth: true }));
    };
    SuggestionsContextMenu.prototype.getSuggestionMenuItems = function () {
        /**
         * Cache existing items (if new suggestions are still in progress) to be
         * returned if new suggestions aren't ready to be displayed.
         */
        var items = this.suggestions;
        /**
         * Get current suggestions from store and see if they're ready to be
         * displayed. If so, create list of items with custom render functions.
         * If not, return existing items.
         */
        var suggestionSet = getStore().currentSuggestions;
        if (suggestionSet && suggestionSet.IsComplete) {
            items = getSuggestionMenuItemsSelector(suggestionSet);
            // Log response rendered (if 3S) and we have a trace ID from 3S.
            if (getStore().isUsing3S && getStore().latestTraceId) {
                lazyLogResponseRendered.importAndExecute(getStore().latestTraceId, new Date());
            }
        }
        return items;
    };
    SuggestionsContextMenu = tslib_1.__decorate([
        observer
    ], SuggestionsContextMenu);
    return SuggestionsContextMenu;
}(React.Component));
export default SuggestionsContextMenu;
//# sourceMappingURL=SuggestionsContextMenu.js.map